import { render, staticRenderFns } from "./UnsubscribeFromEmails.vue?vue&type=template&id=b2672852"
import script from "./UnsubscribeFromEmails.ts?vue&type=script&lang=ts&external"
export * from "./UnsubscribeFromEmails.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports